export type Plan = 'free' | 'premium' | 'vip';

export interface PlanState {
  plan: Plan;
  boostsRemaining: number;
}

interface EntitlementRow {
  plan?: string | null;
  boosts_remaining?: number | null;
}

const KNOWN: ReadonlySet<Plan> = new Set(['free', 'premium', 'vip']);

/**
 * Pure derivation from a `hottr_entitlements` row to the in-app PlanState.
 * Unknown plan strings degrade to `free` — we never let a typo or a
 * forward-rolled enum value escalate a user to a paid tier.
 */
export const derivePlanState = (
  row: EntitlementRow | null | undefined,
): PlanState => {
  const raw = row?.plan ?? 'free';
  const plan: Plan = KNOWN.has(raw as Plan) ? (raw as Plan) : 'free';
  const boostsRaw = row?.boosts_remaining;
  const boosts =
    typeof boostsRaw === 'number' && Number.isFinite(boostsRaw) && boostsRaw > 0
      ? boostsRaw
      : 0;
  return { plan, boostsRemaining: boosts };
};

export const hasPremiumFeatures = (plan: Plan): boolean =>
  plan === 'premium' || plan === 'vip';

export const hasVipFeatures = (plan: Plan): boolean => plan === 'vip';

export const canBoost = (plan: Plan, boostsRemaining: number): boolean =>
  plan !== 'free' && boostsRemaining > 0;
